
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/contact-lp-thanks",
      function () {
        return require("private-next-pages/services/contact-lp-thanks.tsx");
      }
    ]);
  